import React from "react";
import { Navbar } from "reactstrap";

const Header = () => {
    return (
        <Navbar className="eurosportPlayer-header">
            <div className="logo">
                <img className="logo-img"
                    id="logo-eurosportPlayer"
                    alt="logo-eurosportPlayer" />
            </div>
        </Navbar >
    );
};

export default Header;
